import { toolbarClasses } from "@mui/material/Toolbar";
export const Toolbar = {
    MuiToolbar: {
        styleOverrides: {
            root: ({ theme })=>({
                    [`&.${toolbarClasses.gutters}`]: {
                        padding: theme.spacing(0, 1)
                    }
                })
        }
    }
};

//# sourceMappingURL=Toolbar.js.map